//REDUCER
import {  RECIEVE_USER_FEEDBACK, ADD_METED_FEEDBACK_TEXT, SET_METED_FEEDBACK_TAKEN, SET_FEEDBACK_ELIGIBILITY} from '../actions'
import ReactGA from 'react-ga'
import { createAction, createReducer } from '@reduxjs/toolkit'



const initialState = {
	responses: null,
	taken:false,
	isEligible:false,
	isFilledout:false
};

const feedback = createReducer(initialState, (builder) => {
    builder
	.addCase(createAction(RECIEVE_USER_FEEDBACK), (state, action) => {
        state.isEligible = action.json.user.feedback.isEligible;
		state.responses =  action.json.user.feedback.responses;
	})
	.addCase(createAction(ADD_METED_FEEDBACK_TEXT), (state, action) => {
        if(state.responses == null)
		  {
			  state.responses = [];
			  let i;
			  for (i = 0; i < 1; i++) //TODO make 7 dynamic
			  { 
				  state.responses.push({question: "", response: ""})
			  }
		  }
		  
          state.responses[action.qn].question = action.q;
		  state.responses[action.qn].response = action.a;

		  if(action.a.trim().length > 9)
		  {
			state.isFilledout = true;
		  }else
		  {
			state.isFilledout = false;
		  }
		
	})
	.addCase(createAction(SET_FEEDBACK_ELIGIBILITY), (state, action) => {
        state.isEligible = action.bool;
	})
	.addCase(createAction(SET_METED_FEEDBACK_TAKEN), (state, action) => {
        ReactGA.event({
			category: 'User',
			action: 'Feedback Submitted'
		});
		  
		state.taken = action.bool;
		state.isFilledout = false;
	})

})

export default feedback;
	


